(() => {
  const source = document.currentScript;
  let pending;
  const setState = (state) => { source.dataset.searchState = state; };
  const replayQuery = () => {
    document.querySelectorAll('predictive-search').forEach((element) => {
      const value = element.querySelector('input[type="search"]')?.value.trim();
      if (value && element.searchTerm !== value && typeof element.onChange === 'function') element.onChange();
    });
  };
  const loadSearch = () => {
    if (customElements.get('predictive-search')) return Promise.resolve();
    if (pending) return pending;
    setState('loading');
    pending = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = source.dataset.predictiveSearchSrc;
      script.async = true;
      script.onload = () => {
        customElements.whenDefined('predictive-search').then(() => {
          replayQuery();
          setState('ready');
          resolve();
        });
      };
      script.onerror = () => {
        setState('failed');
        pending = undefined;
        reject(new Error('Predictive search unavailable'));
      };
      document.head.appendChild(script);
    });
    return pending;
  };
  const onIntent = (event) => {
    if (event.target?.closest?.('.header__search, predictive-search')) loadSearch().catch(() => {});
  };
  setState('idle');
  document.addEventListener('pointerover', onIntent, { passive: true, capture: true });
  document.addEventListener('pointerdown', onIntent, { passive: true, capture: true });
  document.addEventListener('focusin', onIntent, { capture: true });
  document.addEventListener('input', onIntent, { capture: true });
  document.addEventListener('toggle', onIntent, { capture: true });
})();
